import { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { saveAs } from 'file-saver';
import styles from './GenerateInvoice.module.css'
// ------ Services ------ //
import * as leadCaptureService from '../../../services/leadCaptureService'
// ------ Components ------ //
import LoadingSpinner from "../../../components/Miscellaneous/LoadingSpinner"

const GenerateInvoice = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const exhibitorAccount = location.state    
    const [loaded, setLoaded] = useState(false);
    const [message, setMessage] = useState("")
    const [messageColor, setMessageColor] = useState('green')
    const [invoicesFile, setInvoicesFile] = useState([])
    const [processing, setProcessing] = useState(false)
    const [pdfName, setPdfName] = useState(null);
    const [email, setEmail] = useState(null);
    const changeDateTimeFormat = dateStr => {
        const parsedDate = Date.parse(dateStr)
        const date = new Date(parsedDate)
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        };
        return date.toLocaleString('en-us', options);
    }
    const isEmailInvalid = () => {
        if (!email) return false; // empty field is valid for local download
        const validEmailRegex = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
        const emailParts = email.split('@');

        if (emailParts.length !== 2) return true;
        const account = emailParts[0];
        const domain = emailParts[1];

        if (account.length > 64) return true;
        else if (domain.length > 255) return true;

        const domainParts = domain.split('.');

        if (domainParts.some((part) => part.length > 63)) return true;

        return !(validEmailRegex.test(email));
    }
    const handleChange = e => {
        setEmail(e.target.value);
    }
    const createRequestBody = async () => {

        let requestBody = {}
        requestBody =
        {
            "pdfName": `${pdfName}`,
            "limitedExhibitors": `${exhibitorAccount.id}`,
        }
        return await requestBody;
    }
    const createRequestBodyEmail = async () => {

        let requestBody = {}
        requestBody =
        {
            "email": `${email}`,
            "pdfName": `${pdfName}`,
            "limitedExhibitors": `${exhibitorAccount.id}`,
        }
        return await requestBody;
    }
    const generateInvoicesFile = async () => {
        const getReqBody = await createRequestBody()
        try {
            setMessage('Downloading...')
            setMessageColor('green')
            let invoicesFile = await leadCaptureService.generateExhibitorInvoices(getReqBody)
            if (invoicesFile) {
                setInvoicesFile(invoicesFile);
                setMessage('Download Complete!')
                setMessageColor('green')
            }
            return invoicesFile;

        } catch (err) {
            setMessage('Error: ' + err.message);
            setMessageColor('red')
        }
    }
    const generateEmail = async () => { 
        const getReqBody = await createRequestBodyEmail()
        try {
            await leadCaptureService.emailExhibitorInvoices(getReqBody)
            setMessage('Email sent!')
            setMessageColor('green')
        } catch (err) {
            setMessage('Error: ' + err.message);
            setMessageColor('red')
        }
    }
    function base64ToBlob(base64Data, contentType = 'application/pdf') {
        let byteCharacters = '';
        if (base64Data.split(',').length > 1) {
            byteCharacters = atob(base64Data.split(',')[1]);
        }
        else {
            byteCharacters = atob(base64Data);
        }
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    }
    const handleJSDownload = async (e) => {
        e.preventDefault();
        setProcessing(true)
        if (email && !isEmailInvalid()) {
            setMessage('Sending...')
            setMessageColor('green')
            // send email
            await generateEmail();
            setProcessing(false)
            return;
        }
        let holder = null;
        if (invoicesFile || invoicesFile.length < 1) {
            setMessage('Downloading...')
            setMessageColor('green')
            holder = await generateInvoicesFile();
            setProcessing(false)
        }
        if (invoicesFile && invoicesFile.attachment) {
            let buffer = base64ToBlob(invoicesFile.attachmentBase64);
            // Save the Excel file
            saveAs(new Blob([buffer]), `${invoicesFile.fileName}`);
        }
        if ( holder && holder.attachment) {
            let buffer = base64ToBlob(holder.attachmentBase64);
            // Save the Excel file
            saveAs(new Blob([buffer]), `${holder.fileName}`);
        }
    };
    useEffect(() => {
        // get invoice, create table of items, seperated by 'limitedexhibitors'
        setPdfName(exhibitorAccount.firstName + '_' + exhibitorAccount.lastName + '_' + exhibitorAccount.organization + '.pdf');
        setProcessing(false);
        setLoaded(true);

    }, [])
    return (
        <>{!loaded ? <LoadingSpinner /> :
            <> 
                <div className={styles.invoiceContainer}>
                <br /><br />
                    {
                        <>
                            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
                            <br /><br />
                            <label> <strong>Enter Email address or leave blank to download invoices locally.</strong> </label>
                            <input
                                type='email'
                                value={email}
                                onChange={handleChange} // option selected
                                name='email'
                                placeholder='Enter Email...'
                            />
                            <br /><br />
                            <button className={styles.editButton} onClick={e => handleJSDownload(e)} disabled={processing} >
                                {email && !isEmailInvalid() ? 'Email Invoices' : 'Download Invoices'}
                            </button>
                            {
                                message ?
                                    <h2 style={{ color: messageColor }}>{message}</h2> :
                                    <></>
                            }
                            <br /><br /> <br />
                            <div>
                                <table className={styles.tablePrintNone} style={{  cellspacing: '0', cellpadding: '3' }}>
                                    <tr style={{ border:'none' }}>
                                        <td style={{ width: '10%', align: 'left', valign: 'top', border:'none' }}>
                                            Sold to:
                                        </td>
                                        <td style={{ width: '40%', align: 'left', valign: 'top', border: 'none' }}>
                                            {exhibitorAccount.organization} <br />
                                            {exhibitorAccount.firstName} {exhibitorAccount.lastName} <br />
                                            {exhibitorAccount.address} <br />
                                            {exhibitorAccount.city}, {exhibitorAccount.state ? exhibitorAccount.state.stateName : null} {exhibitorAccount.postalCode} <br />
                                            {exhibitorAccount.country.countryName}
                                        </td>
                                    </tr>
                                </table>
                                <br /> <br />
                                <table className={styles.tablePrint} style={{ border: '1', cellspacing: '0', cellpadding: '3' }}>
                                    <tr>
                                        <th>
                                            Account No.
                                        </th>
                                        <th>
                                            Order No.
                                        </th>
                                        <th>
                                            Invoice Date
                                        </th>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '10%', align: 'center', valign: 'middle' }}>
                                            {exhibitorAccount.refNumber}
                                        </td>
                                        <td style={{ align: 'center', valign: 'middle' }}>
                                            {exhibitorAccount.invoice.invoiceNumber}
                                        </td>
                                        <td style={{ align: 'center', valign: 'middle' }}>
                                            {changeDateTimeFormat(exhibitorAccount.createdDate)}
                                        </td>
                                    </tr>
                                </table>
                                <table className={styles.tablePrint} style={{ cellspacing: '0', cellpadding: '3', border: '1' }}>
                                    <tr>
                                        <th style={{ width: '10%' }}>
                                            Qty
                                        </th>
                                        <th style={{ width: '50%' }}>
                                            Description
                                        </th>
                                        <th style={{ width: '20%' }}>
                                            Unit Price
                                        </th>
                                        <th style={{ width: '20%' }}>
                                            Extended Price
                                        </th>
                                    </tr>
                                    {
                                        exhibitorAccount.invoice.productOrders && exhibitorAccount.invoice.productOrders.length > 0 ?
                                            exhibitorAccount.invoice.productOrders.map((orderItem, idx) => (
                                                <>
                                                    {

                                                        (orderItem.cancelled === undefined || orderItem.cancelled === false) && orderItem.quantity && orderItem.quantity > 0 ?
                                                            <tr>
                                                                <td style={{ valign: 'middle', align: 'right' }}>
                                                                    {orderItem.quantity}
                                                                </td>
                                                                <td style={{ valign: 'middle', align: 'left' }}>
                                                                    {orderItem.productName}
                                                                </td>
                                                                <td style={{ valign: 'middle', align: 'right' }}>
                                                                    ${orderItem.purchasePrice.toFixed(2)}
                                                                </td>
                                                                <td style={{ valign: 'middle', align: 'right' }}>
                                                                    ${(orderItem.quantity * orderItem.purchasePrice).toFixed(2)}
                                                                </td>
                                                            </tr>
                                                            : <></>
                                                    }
                                                </>
                                            ))
                                            : <></>
                                    }
                                    <tr>
                                        <td>
                                            &nbsp;
                                        </td>
                                        <td >
                                            &nbsp;
                                        </td>
                                        <td >
                                            &nbsp;
                                        </td>
                                        <td >
                                            &nbsp;
                                        </td>
                                    </tr>
                                </table>
                                <br /><br />
                                <table className={styles.tablePrint} style={{cellspacing: '0', cellpadding: '3', border: '1' }}>
                                    <tr>
                                        <th style={{ width: '16%' }}>
                                            Subtotal
                                        </th>
                                        <th style={{ width: '16%' }}>
                                            Amount Received
                                        </th>
                                    </tr>
                                    <tr>
                                        <td style={{ align: 'center', valign: 'middle' }}>
                                            ${exhibitorAccount.invoice.order.orderTotal.toFixed(2)}
                                        </td>
                                        <td style={{ align: 'center', valign: 'middle' }}>
                                            ${exhibitorAccount.invoice.order.orderTotal.toFixed(2)}
                                        </td>
                                    </tr>
                                </table>
                                <br /><br />    
                                <hr style={{ borderTop: '1px dashed black;' }}></hr>
                            </div>
                            <br />

                        </>
                    }
                    <br /> <br />
                    <Link to={`/ExhibitorConfig`} title="Review or edit invoice." state={exhibitorAccount}> Edit Invoice ...</Link>
                    <br /><br /><br /><br /><br />
                    <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
                </div>
            </>
                        }
        </>

    );
}

export default GenerateInvoice;